(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.archive-banner');
    if (!sections.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    sections.forEach(function (section) {
      var video = section.querySelector('.archive-banner__video');
      if (!video) return;

      var mobileDisabled = section.classList.contains('archive-banner--mobile-video-disabled');
      if (mobileDisabled && window.matchMedia('(max-width: 749px)').matches) return;

      function startVideo() {
        video.load();
        video.play().catch(function () {});
      }

      if (!('IntersectionObserver' in window)) {
        startVideo();
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              startVideo();
              observer.unobserve(section);
            }
          });
        },
        { rootMargin: '200px' }
      );
      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
